var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mapToCommonStatusIntegration, mapToCommonStatusWabaChannel, mapToLabelStatusIntegration, mapToLabelDisplayNameStatus, } from "@/api/admin/statuses";
var UNSET_LABEL = "unset";
var UIModelChannels = /** @class */ (function () {
    function UIModelChannels(response) {
        this.channels = response.channels.map(function (channel) { return new UIModelChannel(channel); });
        this.total = response.total;
    }
    return UIModelChannels;
}());
export { UIModelChannels };
var UIModelChannel = /** @class */ (function () {
    function UIModelChannel(response) {
        var _this = this;
        this.update = function (response) {
            var _a;
            _this.id = response.id;
            _this.type = response.type;
            _this.partnerId = response.partnerId;
            _this.clientId = response.clientId;
            _this.projectId = response.projectId;
            _this.consents = new UIModelConsents(response.consents);
            _this.status = response.status;
            _this.integrationId = response.integrationId;
            _this.wabaAccountId = response.wabaAccountId;
            _this.externalId = response.externalId;
            _this.profileInfo = new UIModelProfileInfo(response.profileInfo);
            _this.setupInfo = new UIModelSetupInfo(response.setupInfo);
            _this.createdAt = new Date(response.createdAt);
            _this.modifiedAt = new Date(response.modifiedAt);
            _this.integration = response.integration
                ? new UIModelIntegration(response.integration)
                : undefined;
            _this.externalWabaChannelStatus = _this.externalId ? "live" : "draft";
            _this.displayNameVerificationStatus =
                mapToCommonStatusWabaChannel[_this.status];
            _this.redirectUrl = response.redirectUrl;
            _this.billingStartedAt = response.billingStartedAt
                ? new Date(response.billingStartedAt)
                : null;
            _this.version = response.version;
            _this.accountMode = response.accountMode;
            _this.cancelledAt = response.cancelledAt;
            _this.terminatedAt = response.terminatedAt;
            _this.isMigrated = response.isMigrated ? response.isMigrated : false;
            _this.metaStatus = response.metaStatus;
            _this.availabilityStatus = response.availabilityStatus;
            _this.currentLimit = response.currentLimit;
            _this.currentQualityRating = response.currentQualityRating;
            _this.isOba = response.isOba || false;
            _this.lastDowngradeAt = response.lastDowngradeAt || "";
            _this.lastUpgradeAt = response.lastUpgradeAt || "";
            _this.isAllowedToSendTemplateMessage =
                response.isAllowedToSendTemplateMessage;
            _this.channelOrigin = response.channelOrigin;
            _this.currentBalance = response.currentBalance;
            _this.tier = response.tier;
            _this.settings = response.settings;
            _this.channelSettings = (_a = response.channelSettings) !== null && _a !== void 0 ? _a : null;
        };
        this.update(response);
    }
    Object.defineProperty(UIModelChannel.prototype, "formValues", {
        get: function () {
            return __assign(__assign({ wabaAccountId: this.wabaAccountId, type: this.type }, this.setupInfo), this.profileInfo);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIModelChannel.prototype, "isReadyToSubmit", {
        get: function () {
            return (this.setupInfo.checkIfRequiredToSubmitFieldsAreFilled &&
                this.profileInfo.checkIfRequiredToSubmitFieldsAreFilled);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIModelChannel.prototype, "numberRegistrationStatus", {
        get: function () {
            return this.integration
                ? mapToCommonStatusIntegration[this.integration.state]
                : "draft";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIModelChannel.prototype, "isAnyStatusSetToRejected", {
        get: function () {
            return [this.externalWabaChannelStatus, this.displayNameVerificationStatus];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIModelChannel.prototype, "mainStatus", {
        get: function () {
            if (this.integration &&
                mapToCommonStatusIntegration[this.integration.state] === "live") {
                return "live";
            }
            else {
                if (mapToCommonStatusWabaChannel[this.status] !== "draft") {
                    return "pending";
                }
                else {
                    return "draft";
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIModelChannel.prototype, "statuses", {
        get: function () {
            return {
                main: {
                    label: "",
                    indicator: this.mainStatus,
                },
                externalWabaChannel: {
                    label: this.externalWabaChannelStatus,
                    indicator: this.externalWabaChannelStatus,
                },
                displayNameVerification: {
                    label: mapToLabelDisplayNameStatus(this.status),
                    indicator: this.displayNameVerificationStatus,
                },
                numberRegistration: {
                    label: this.integration
                        ? mapToLabelStatusIntegration[this.integration.state]
                        : UNSET_LABEL,
                    indicator: this.numberRegistrationStatus,
                },
            };
        },
        enumerable: false,
        configurable: true
    });
    return UIModelChannel;
}());
export { UIModelChannel };
var UIModelConsents = /** @class */ (function () {
    function UIModelConsents(response) {
        (this.note = response.note),
            (this.signedAt =
                typeof response.signedAt === "string"
                    ? new Date(response.signedAt)
                    : response.signedAt),
            (this.url = response.url);
    }
    Object.defineProperty(UIModelConsents.prototype, "status", {
        get: function () {
            return this.signedAt ? "Approved" : "Pending";
        },
        enumerable: false,
        configurable: true
    });
    return UIModelConsents;
}());
export { UIModelConsents };
var UIModelProfileInfo = /** @class */ (function () {
    function UIModelProfileInfo(response) {
        this.pictureUrl = response.pictureUrl;
        this.aboutText = response.aboutText;
        this.businessVertical = response.businessVertical;
        this.businessDescription = response.businessDescription;
        this.useCaseDescription = response.useCaseDescription;
        this.streetName = response.streetName;
        this.city = response.city;
        this.zipCode = response.zipCode;
        this.country = response.country;
        this.contactEmail = response.contactEmail;
        this.webpageUrl = response.webpageUrl;
    }
    Object.defineProperty(UIModelProfileInfo.prototype, "checkIfRequiredToSubmitFieldsAreFilled", {
        get: function () {
            return !!(this.pictureUrl &&
                this.aboutText &&
                this.businessVertical &&
                this.businessDescription &&
                this.useCaseDescription &&
                this.streetName &&
                this.city &&
                this.zipCode &&
                this.country &&
                this.contactEmail &&
                this.webpageUrl);
        },
        enumerable: false,
        configurable: true
    });
    return UIModelProfileInfo;
}());
export { UIModelProfileInfo };
var UIModelSetupInfo = /** @class */ (function () {
    function UIModelSetupInfo(response) {
        this.phoneNumber = response.phoneNumber;
        this.phoneName = response.phoneName;
        this.verificationMethod = response.verificationMethod;
        this.defaultLanguage = response.defaultLanguage || null;
        this.wasInUse = response.wasInUse;
        this.ivr = response.ivr;
        this.certificate = response.certificate;
        this.error = response.error || null;
        this.registrationError = response.registrationError || null;
    }
    Object.defineProperty(UIModelSetupInfo.prototype, "checkIfRequiredToSubmitFieldsAreFilled", {
        get: function () {
            return !!(this.phoneNumber &&
                this.phoneName &&
                this.verificationMethod &&
                this.defaultLanguage &&
                typeof this.wasInUse === "boolean" &&
                typeof this.ivr === "boolean");
        },
        enumerable: false,
        configurable: true
    });
    return UIModelSetupInfo;
}());
export { UIModelSetupInfo };
var UIModelIntegration = /** @class */ (function () {
    function UIModelIntegration(response) {
        var _this = this;
        this.update = function (response) {
            _this.appId = response.app_id;
            _this.createdAt = new Date(response.created_at);
            _this.modifiedAt = new Date(response.modified_at);
            _this.id = response.id;
            _this.username = response.username;
            _this.password = response.password;
            _this.address = response.address;
            _this.parameters = response.parameters
                ? new IntegrationParameters(response.parameters)
                : undefined;
            _this.stackId = response.stack_id;
            _this.state = response.state;
            _this.token = response.token;
            _this.type = response.type;
            _this.enabled = response.enabled;
            _this.premium = response.premium;
            _this.hostingPlatform = response.hostingPlatform;
        };
        this.update(response);
    }
    return UIModelIntegration;
}());
export { UIModelIntegration };
var UIModelIntegrations = /** @class */ (function () {
    function UIModelIntegrations(response) {
        this.integrations = response.integrations.map(function (integration) { return new UIModelIntegration(integration); });
        this.total = response.total;
    }
    return UIModelIntegrations;
}());
export { UIModelIntegrations };
var IntegrationParameters = /** @class */ (function () {
    function IntegrationParameters(response) {
        this.appName = response.app_name;
        this.defaultLanguage = response.default_language;
        this.namespace = response.namespace;
        this.organisation = response.organisation;
        this.certificate = response.certificate;
        this.verificationMethod = response.verification_method;
    }
    return IntegrationParameters;
}());
export { IntegrationParameters };
//# sourceMappingURL=data:application/json;base64,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